import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Product, CartItem } from '../types';

interface CartState {
    items: CartItem[];
    isDrawerOpen: boolean;
    addItem: (product: Product) => void;
    removeItem: (productId: string) => void;
    updateQuantity: (productId: string, quantity: number) => void;
    clearCart: () => void;
    setIsDrawerOpen: (isOpen: boolean) => void;
    getTotalItems: () => number;
}

export const useCartStore = create<CartState>()(
    persist(
        (set, get) => ({
            items: [],
            isDrawerOpen: false,
            addItem: (product) => {
                set((state) => {
                    const existingItem = state.items.find((item) => item.product.id === product.id);
                    if (existingItem) {
                        const updatedItem = { ...existingItem, quantity: existingItem.quantity + 1 };
                        return {
                            items: [updatedItem, ...state.items.filter(item => item.product.id !== product.id)],
                            isDrawerOpen: true,
                        };
                    }
                    return {
                        items: [{ product, quantity: 1 }, ...state.items],
                        isDrawerOpen: true
                    };
                });
            },
            removeItem: (productId) => {
                set((state) => ({
                    items: state.items.filter((item) => item.product.id !== productId),
                }));
            },
            updateQuantity: (productId, quantity) => {
                set((state) => ({
                    items: state.items.map((item) =>
                        item.product.id === productId ? { ...item, quantity: Math.max(1, quantity) } : item
                    ),
                }));
            },
            clearCart: () => set({ items: [] }),
            setIsDrawerOpen: (isOpen) => set({ isDrawerOpen: isOpen }),
            getTotalItems: () => {
                return get().items.reduce((total, item) => total + item.quantity, 0);
            },
        }),
        {
            name: 'guzman-cart-storage',
        }
    )
);
